import { ConsultationPaymentStatus, ConsultationStatus } from '@/data/constants';
import { getAuthData } from '@/data/service/authService';
import type { AuthData } from '@/types';
import type { ConsultationModel, ConsultationStatusResponse } from '../Consultation.types';

const isCancelled = (statusValue: number) => statusValue === ConsultationStatus.cancelled;
const isSpotConsultationCancellationSupported = (authData: AuthData) => {
  const { isManager, isNurse, isSuperAdmin } = authData;
  return isNurse || isManager || isSuperAdmin;
};
const isCompletedOrRescheduled = (statusId: number) =>
  [ConsultationStatus.completed, ConsultationStatus.re_scheduled].includes(statusId);
const isPaidOrQueued = (showConsultation: ConsultationModel) =>
  showConsultation.payment_queued || showConsultation.payment_status === ConsultationPaymentStatus.PAID;
const isDoctorSupportedConsultStatusSelectorOption = (statusId: number) => {
  const DOCTOR_CONSULT_STATUS_SELECTOR_OPTIONS = [
    ConsultationStatus.pending,
    ConsultationStatus.awaiting_document,
    ConsultationStatus.scheduled,
    ConsultationStatus.no_show
  ];
  return DOCTOR_CONSULT_STATUS_SELECTOR_OPTIONS.includes(statusId);
};

export const mapConsultationStatuses = (
  showConsultation: ConsultationModel,
  consultationStatusResponse: ConsultationStatusResponse[],
  ffAwaitingDocumentDoctorConsultStatus: boolean
) => {
  const authData = getAuthData();
  const canCancelSpotConsult = isSpotConsultationCancellationSupported(authData);

  const mappedData = consultationStatusResponse
    ?.map((status) => ({ name: status.name, value: status.id }))
    .filter(({ value }) => {
      if (ffAwaitingDocumentDoctorConsultStatus && authData.isDoc) {
        return isDoctorSupportedConsultStatusSelectorOption(value);
      }

      if (isCancelled(value)) {
        if (
          !canCancelSpotConsult ||
          isCompletedOrRescheduled(showConsultation?.status_id) ||
          isPaidOrQueued(showConsultation)
        ) {
          return false;
        }
        return true;
      }

      if (value !== ConsultationStatus.ineligible) {
        return true;
      }

      if (!showConsultation?.Nurse) {
        return false;
      }

      if (showConsultation?.consult_type === 'Initial') {
        return true;
      }
      return false;
    });

  return mappedData;
};
